/* eslint-disable radix */
// helper register if function to compare two value
/// <reference types="../../node_modules/handlebars/types" /> #
Handlebars.registerHelper({
    or: function (v1, v2) {
        return v1 || v2;
    },
    trim: function (str) {
        return str.replace(/\s/g, '');
    },
    add: function (v1, v2) {
        return parseFloat(v1) + parseFloat(v2);
    },
    equal: function (type, value, options) {
        if (type === value) {
            return options.fn(this);
        }
        return options.inverse(this);
    },
    unequal: function (type, value, options) {
        if (type === value) {
            return options.inverse(this);
        }
        return options.fn(this);
    },
    equals: function (base, conditions, options) {
        var arr = $.map(conditions.split('|'), $.trim);
        if (arr.indexOf(base) !== -1) {
            return options.fn(this);
        }
        return options.inverse(this);
    },
    unequals: function (base, conditions, options) {
        var arr = $.map(conditions.split('|'), $.trim);
        if (arr.indexOf(base) === -1) {
            return options.fn(this);
        }
        return options.inverse(this);
    },
    match: function (str, value, options) {
        if (str.match(value)) {
            return options.fn(this);
        }
        return options.inverse(this);
    },
    no_match: function (str, value, options) {
        if (!str.match(value)) {
            return options.fn(this);
        }
        return options.inverse(this);
    },
    // tslint:disable-next-line: variable-name
    pluralize: function (num, single, plural) {
        var number = num;
        if ($.type(number) === 'string') {
            // tslint:disable-next-line: radix
            number = parseInt(number);
        }
        if (number === 1) {
            return single;
        }
        return plural;
    },
    capitalize: function (str) {
        return str.replace(/^./, str[0].toUpperCase());
    },
    grt: function (v1, v2, options) {
        return v1 > v2 ? options.fn(this) : options.inverse(this);
    },
    even: function (v, options) {
        return v % 2 ? options.fn(this) : options.inverse(this);
    },
    odd: function (v, options) {
        return v % 2 ? options.inverse(this) : options.fn(this);
    },
    increment: function (num, step) {
        // tslint:disable-next-line: radix
        // eslint-disable-next-line radix
        return parseInt(num) + parseInt(step);
    },
    decrement: function (num, step) {
        return num - step;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fullName: function (fName, arr, index) {
        //        var lastName = arr[index + 1].value;
        //        return fName + ' ' + lastName;
    },
    mediaType: function (v1, v2, options) {
        var ext = v1.split('.').pop().toLowerCase();
        var type = '';
        if ($.inArray(ext, ['gif', 'png', 'jpg', 'jpeg', 'tif', 'webp']) !== -1) {
            type = 'image';
        }
        return v2 === type ? options.fn(this) : options.inverse(this);
    },
    getFormattedDate: function (date, format) {
        return $.ezdia.date.view({ format: format }, date);
    },
    getAccountName: function (account) {
        return $.ezdia.getAccountName(account);
    },
    getRoleName: function (role) {
        return $.ezdia.getRoleName(role);
    },
    numberFormat: function (number) {
        var num = number;
        /* Fix for google rank templet */
        if ($(num).length) {
            num = $(num).text();
        }
        /* End Fix for google rank templet */
        return $.ezdia.digits(num);
    },
    formControlAppend: function (column, options) {
        var config = column.config || {};
        var showAppend = config.showAppend === true;
        if (showAppend ||
            (config.showAppend !== false && column.edittype === 'tag')) {
            return options.fn(this);
        }
        return options.inverse(this);
    },
    formControlDelete: function (column, options) {
        var config = column.config || {};
        if (config.showDelete !== false &&
            (column.isValue || column.values || column.values === '0')) {
            return options.fn(this);
        }
        return options.inverse(this);
    },
    defaultColumnLayout: function (column) {
        return $.ezdia.defaultColumnLayout(column);
    },
    getFileSize: function (sizeparam) {
        var size = sizeparam.toString();
        var divideBy = 1000;
        var unit = ' KB';
        if (size.length > 6) {
            divideBy *= divideBy;
            unit = ' MB';
        }
        return (size / divideBy).toFixed(1) + unit;
    },
    hbGetCsvEleCount: function (list) {
        return list.length;
    },
    inArray: function (array, item, options) {
        var index = array.indexOf(item);
        if (index !== -1) {
            return options.fn(this);
        }
        return options.inverse(this);
    },
    gdShowMore: function (v1, v2, v3, options) {
        if (v1 || v2 || v3) {
            return options.fn(this);
        }
        return options.inverse(this);
    }
});
Handlebars.registerHelper('fieldType', function fieldType(type, value, options) {
    var arr = [];
    var inputType = function inputType() {
        return $.inArray(type.toLowerCase(), arr) !== -1;
    };
    switch (value) {
        case 'textarea':
            arr = ['textarea', 'html', 'inputlist', 'inputtab', 'groupField', 'json'];
            return inputType() ? options.fn(this) : options.inverse(this);
        case 'select':
            arr = [
                'singlechoice',
                'dropdown',
                'status',
                'country',
                'visualstatus',
                'multichoice'
            ];
            return inputType() ? options.fn(this) : options.inverse(this);
        case 'checkbox radio':
            arr = ['checkbox', 'radio'];
            return inputType() ? options.fn(this) : options.inverse(this);
        case 'upload':
            arr = ['file', 'filetype'];
            return inputType() ? options.fn(this) : options.inverse(this);
        case 'image':
            arr = ['image'];
            return inputType() ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});
Handlebars.registerHelper('commentType', function commentType(type, options) {
    switch (type) {
        case 'save':
        case 'return':
        case 'update':
        case 'submit':
            return options.fn(this);
        default:
            return options.inverse(this);
    }
});
Handlebars.registerHelper('stringifyJSON', function stringifyJSON(context) {
    return JSON.stringify(context);
});
Handlebars.registerHelper('qreadonlyView', function qreadonlyView(column) {
    return $.ezdia.inputs.readonlyView({
        column: column,
        value: column.values
    }, 'quickaction');
});
Handlebars.registerHelper('readonlyView', function readonlyView(obj, type) {
    return $.ezdia.inputs.readonlyView(obj, type);
});
Handlebars.registerHelper('editableView', function editableView(obj, index, type) {
    var column = obj.column;
    var value = '';
    column.id = column.name + index;
    var input = $.ezdia.inputs.getMarkup(obj, type);
    value = column.edittype !== 'hidden' ? input.prop('outerHTML') : input;
    $.ezdia.widgets.init(obj, type);
    return value;
});
Handlebars.registerHelper('gscount', function gscount(array, key) {
    var count = 0;
    $.each(array, function each(i, obj) {
        var num = obj[key];
        // tslint:disable-next-line: radix
        num = num ? parseInt(num) : 0;
        count += num;
    });
    return $.ezdia.digits(count);
});
Handlebars.registerHelper('if_eq', function ifeq(a, b, opts) {
    if (a === b) {
        return opts.fn(this);
    }
    return opts.inverse(this);
});
Handlebars.registerHelper('trialDetailsArraytoList', 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function trialDetailsArraytoList(str, key) {
    return $.ezdia.inputs.qaView(str);
});
Handlebars.registerHelper('parseToJSON', function parseToJSON(str) {
    var rowData = JSON.parse(str);
    var html = '';
    var value = '';
    rowData.forEach(function forEach(rowValue) {
        html += '<tr class="input-list input-list-group" data-row="groupFields">';
        value = rowValue.toolname ? rowValue.toolname : '';
        html += "<td class=\"form-group-fields\" data-row=\"input\" data-column=\"toolname\">" + value + "</td>";
        value = rowValue.projecttype ? rowValue.projecttype : '';
        html += "<td class=\"form-group-fields\" data-row=\"input\" data-column=\"projecttype\">" + value + "</td>";
        value = rowValue.quantity ? rowValue.quantity : '';
        html += "<td class=\"form-group-fields\" data-row=\"input\" data-column=\"quantity\">" + value + "</td>";
        value = rowValue.unit_price ? rowValue.unit_price : '';
        html += "<td class=\"form-group-fields\" data-row=\"input\" data-column=\"unit_price\">" + value + "</td>";
        value = rowValue.discount ? rowValue.discount : '';
        html += "<td class=\"form-group-fields\" data-row=\"input\" data-column=\"discount\">" + value + "</td>";
        value = rowValue.price ? rowValue.price : '';
        html += "<td class=\"form-group-fields\" data-row=\"input\" data-column=\"price\">" + value + "</td>";
        value = rowValue.final_price ? rowValue.final_price : '';
        html += "<td class=\"form-group-fields\" data-row=\"input\" data-column=\"final_price\">" + value + "</td>";
        html += '</tr>';
    });
    return html;
});
Handlebars.registerHelper('trialAccuracy', function trialAccuracy(obj, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
key) {
    var answers = obj.correct_answers && (obj.correct_answers.value || '');
    var questions = +obj.total_questions.value;
    var percentage = 0;
    if (answers.toLowerCase() === 'na') {
        return '';
    }
    answers = +answers;
    percentage = Math.floor((answers / questions) * 100);
    var content = "<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"" + percentage + "\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: " + percentage + "%\"></div></div>" + percentage + "%";
    return content;
});
Handlebars.registerHelper('secondsToHHMMSS', function secondsToHHMMSS(seconds) {
    // tslint:disable-next-line: radix
    var hour = parseInt((seconds / 3600));
    // tslint:disable-next-line: radix
    var min = parseInt((seconds / 60)) - hour * 60;
    // tslint:disable-next-line: radix
    var sec = parseInt((seconds - (min * 60 + hour * 3600)));
    var ret = '';
    if (hour) {
        ret += ("0" + hour).slice(-2) + "h:";
    }
    if (min) {
        ret += ("0" + min).slice(-2) + "m:";
    }
    ret += ("0" + sec).slice(-2) + "s";
    return ret;
});
